import {RECEIVE_FACILITIES_DATA, ERROR_RETRIEVING_FACILITIES_DATA} from "../actions/facilitiesActions";

const initialState = [];

export default function facilitiesReducer (state = initialState, action) {
  switch (action.type) {
    case RECEIVE_FACILITIES_DATA:
      return {
        ...state,
        rawFacilities: action.payload
      };
    case ERROR_RETRIEVING_FACILITIES_DATA:
      return {
        ...initialState,
        error: action.payload
      };
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/reducers/facilitiesReducer.js